import { RestoreCmd } from "./cmd/RestoreCmd";
import { GrahamScan } from "../maths/GrahamScan";
import { Matrix } from "../maths/Matrix";
import { Point } from "../maths/Point";
import { Rectangle } from "../maths/Rectangle";
import { Pool } from "../utils/Pool";
import { SaveCmd } from "./cmd/SaveCmd";
export class GraphicsBounds {
    destroy() {
        this._cached = false;
        this._bounds = null;
        this._bound2 = null;
        Pool.recover("GraphicsBounds", this);
    }
    static create() {
        return Pool.getItemByClass("GraphicsBounds", GraphicsBounds);
    }
    reset() {
        this._cached = false;
    }
    getBounds(g) {
        if (!this._cached) {
            if (g._useSpriteRect) {
                this._bounds = (this._bounds || new Rectangle()).setTo(0, 0, g.owner.width, g.owner.height);
                this._bound2 = this._bounds.getBoundPoints(this._bound2);
            }
            else {
                this._bound2 = this._getCmdPoints(g);
                this._bounds = Rectangle._getWrapRec(this._bound2, this._bounds);
            }
            this._cached = true;
        }
        return this._bounds;
    }
    getBoundPoints(g) {
        this.getBounds(g);
        return this._bound2;
    }
    _getCmdPoints(g) {
        let points = this._bound2 || (this._bound2 = []);
        points.length = 0;
        let cmds = g.cmds;
        let sp = g.owner;
        if (cmds.length == 0)
            return points;
        _assembler.allPoints = points;
        _assembler.width = sp._width;
        _assembler.height = sp._height;
        _assembler.matrix.identity();
        let matrixs = _tempMatrixArrays;
        matrixs.length = 0;
        for (let i = 0, n = cmds.length; i < n; i++) {
            let cmd = cmds[i];
            switch (cmd.cmdID) {
                case SaveCmd.ID:
                    matrixs.push(_assembler.matrix);
                    _assembler.matrix = _assembler.matrix.clone();
                    break;
                case RestoreCmd.ID:
                    _assembler.matrix = matrixs.pop();
                    break;
                default:
                    _assembler.points.length = 0;
                    if (cmd.getBounds)
                        cmd.getBounds(_assembler);
                    else
                        _tempRect.setTo(sp.x, sp.y, sp._width, sp._height).getBoundPoints(_assembler.points);
                    if (_assembler.points.length > 0)
                        _assembler.flushPoints();
                    break;
            }
        }
        if (points.length > 200) {
            let rect = Rectangle._getWrapRec(points, _tempRect);
            points.length = 0;
            rect.getBoundPoints(points);
        }
        else if (points.length > 8)
            GrahamScan.scanPList(points, points);
        return points;
    }
}
class GraphicsBoundsAssembler {
    constructor() {
        this.points = [];
        this.matrix = new Matrix();
    }
    flushPoints(dx, dy, matrix) {
        if (dx == null)
            dx = 0;
        if (dy == null)
            dy = 0;
        if (matrix) {
            this.matrix.copyTo(_tempMatrix);
            _tempMatrix.concat(matrix);
            matrix = _tempMatrix;
        }
        else
            matrix = this.matrix;
        let len = this.points.length;
        let _tempPoint = Point.TEMP;
        for (let i = 0; i < len; i += 2) {
            _tempPoint.setTo(this.points[i] + dx, this.points[i + 1] + dy);
            if (_tempPoint.x == null)
                _tempPoint.x = 0;
            if (_tempPoint.y == null)
                _tempPoint.y = 0;
            matrix.transformPoint(_tempPoint);
            this.allPoints.push(_tempPoint.x, _tempPoint.y);
        }
        this.points.length = 0;
    }
    concatMatrix(matrix) {
        matrix.copyTo(_tempMatrix);
        _tempMatrix.concat(this.matrix);
        _tempMatrix.copyTo(this.matrix);
    }
}
const _assembler = new GraphicsBoundsAssembler();
const _tempMatrix = new Matrix();
const _tempMatrixArrays = [];
const _tempRect = new Rectangle();
